import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { IFailedPayload } from '../../types/Allocation.types';
import {
  IPaymentListResponse,
  PaymentList,
  PaymentListPayload,
} from '../../types/AllocationPayment.types';

export interface PaymentListState {
  data: PaymentList[] | [];
  page: number;
  pageSize: number;
  totalRecords: number;
  loading: boolean;
  error: IFailedPayload | null;
}

export const PaymentInitState: PaymentListState = {
  data: [],
  page: 0,
  pageSize: 0,
  totalRecords: 0,
  loading: false,
  error: null,
};

const paymentListSlice = createSlice({
  name: 'paymentListTable',
  initialState: PaymentInitState,
  reducers: {
    fetchPaymentList(state, action: PayloadAction<PaymentListPayload>) {
      state.loading = true;
      state.error = null;
    },
    fetchPaymentListSuccess(
      state,
      action: PayloadAction<IPaymentListResponse>
    ) {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.total_records;
      state.pageSize = action.payload.data.page_size;
      state.page = action.payload.data.page;
      state.loading = false;
      state.error = null;
    },
    fetchPaymentListFailure(state, action: PayloadAction<IFailedPayload>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchPaymentList,
  fetchPaymentListSuccess,
  fetchPaymentListFailure,
} = paymentListSlice.actions;

export default paymentListSlice.reducer;
